// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__m_aY5","footerOne":"Footer_footerOne__xep9Z","footerTwo":"Footer_footerTwo__6wqoD"};